module.exports = __webpack_public_path__ + "static/media/05.7958d3b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/project/monuks/05.png
// module id = 139
// module chunks = 0